import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

// Hadid & Vance Header — STRICT GRID style. Brand left, route ledger right
// with route codes 01.HV, 02.HV etc. Concrete-grey bg.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`sticky top-0 z-40 bg-[#DADCD6] border-b border-[#1E3A5F]/15 transition-all duration-500 ${scrolled ? 'h-12' : 'h-16'}`}>
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 h-full flex items-center justify-between gap-6">
        <button onClick={() => setPage('home')} className="flex items-baseline gap-2.5" data-testid="arch-logo">
          <span className="font-serif text-xl text-[#1E3A5F]" dangerouslySetInnerHTML={{ __html: META.brand }} />
          <span className="font-mono text-[9px] tracking-[0.3em] uppercase text-[#1E3A5F]/55 hidden sm:inline">/ {META.tagline}</span>
        </button>
        <nav className="hidden lg:flex items-center gap-1">
          {ROUTES.map((r, i) => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`arch-nav-${r.id}`}
              className={`group flex items-baseline gap-2 px-3 py-1.5 font-mono text-[10px] tracking-[0.22em] uppercase transition-colors ${page === r.id ? 'text-[#1E3A5F] bg-[#E5C61F]' : 'text-[#1E3A5F]/55 hover:text-[#1E3A5F]'}`}>
              <span className="opacity-65">0{i + 1}.HV</span>
              <span>{r.label}</span>
            </button>
          ))}
        </nav>
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#1E3A5F]/55 hidden md:block">REG · ARB-2003 · est. {META.est}</div>
      </div>
    </header>
  );
}
